<template>
  <div
    v-if="activePositionItem"
    v-bind:class="['position-drawer', positionDrawer ? 'visible' : 'hidden']">

    <v-card
      elevation="14"
      class="position-drawer"
    >
      <v-btn class="close-button" icon @click="positionDrawer = false">
        <v-icon >mdi-close</v-icon>
      </v-btn>
      <v-container fluid>
        <v-row align-content-md="center" align="center">
          <v-col cols="2" md="2">
            <div
              v-if="activePositionItem.imageURL" class="position-logo"
              v-bind:style="{ 'background-image': 'url(' + activePositionItem.imageURL + ')' }" >
            </div>
            <div v-else class="position-logo">
              <p style="width:100%;margin-bottom: 0;">{{ activePositionItem.organization }}</p>
            </div>
          </v-col>
          <v-col cols="6" md="6">
            <p class="position-title">{{ activePositionItem.title }}</p>
            <p class="position-subtitle">{{ activePositionItem.organization }}</p>
            <div class="position-tag-wrapper" v-if="activePositionItem.clustering.categories[0]">
              <span
                v-bind:class="[ 'position-tag', activePositionItem.clustering.categories[0].label.toLowerCase()]">
                {{ activePositionItem.clustering.categories[0].label }}
              </span>
            </div>
          </v-col>
          <v-col cols="2" md="2">
            <p class="position-title">{{ activePositionItem.location.city }}</p>
            <p class="position-subtitle">{{ activePositionItem.location.area }}</p>
          </v-col>
          <v-col cols="2" md="2">
            <v-btn icon class="position-open" @click="openUrl(activePositionItem.url)" >
               <v-icon>mdi-open-in-new</v-icon>
            </v-btn>
            <v-btn icon @click="saveFavorite()">
              <v-icon v-if="!isFavorite">mdi-star-outline</v-icon>
              <v-icon color="primary" v-else>mdi-star</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'ActivePositionCard',
  data() {
    return {
      positionDrawer: false,
    };
  },
  watch: {
    activePositionItem() {
      if (this.activePositionItem) {
        this.activePositionID = this.activePositionItem.id;
        this.positionDrawer = true;
      }
    },
  },
  computed: {
    activePositionItem() {
      return this.$store.state.selectedPosition;
    },
    isFavorite() {
      return this.$store.state.userFavorites.findIndex(item => item.id == this.activePositionItem.id) > -1;
    }
  },
  methods: {
    openUrl(url) {
      window.open(url);
    },
    saveFavorite(){
      this.$store.dispatch("commitFavorite", { jobId: this.activePositionItem.id, action: this.isFavorite ? 'remove' : 'add' });
    }
  },
};
</script>

<style scoped>
.position-drawer {
  /* border-radius: 16px !important; */
  /* color: #fff; */
  padding: 0 1rem;
  z-index: 9000 !important;
}
.position-logo {
  width: 100%;
  text-transform: uppercase;
  font-size: 10px;
  line-height: 1;
  text-align: center;
  display: flex;
  align-content: center;
  align-items: center;
  height: 64px;
  color: rgba(0,0,0,.5);
  border-radius: 3px;
  background-color: #fff;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}
.close-button {
  position: absolute;
  top: 0;
  right: 0;
}

.position-drawer {
  display: block !important;
  position: fixed !important;
  bottom: 8px;
  left: 50%;
  margin-left: -44vw;
  width: 88vw;
  z-index: 5;
  background: #fff;
  transition: transform .3s ease-in-out, opacity .5s linear;
}
.position-drawer.visible {
  transform: translateY(0);
  opacity: 1;
}
.position-drawer.hidden {
  transform: translateY(100px);
  opacity: 0;
}

.position-title {
  font-size: 1em;
  font-weight: 400;
  margin-bottom: 0;
}
.position-subtitle {
  font-size: 1em;
  opacity: 0.7;
  margin-bottom: 0;
}
.position-tag-wrapper {
  width: 100%;
  margin-bottom: 1em;
}
.position-tag {
  font-size: 0.9em;
  color: rgba(0, 45, 160, 1);
  text-transform: uppercase;
}

@media screen and (min-width: 992px) {
  .position-drawer{
    margin-left: -25vw;
    width: 50vw;
  }

  .position-title{
    font-size: 1.2em;
  }
}
</style>
